import { createPageApp } from '@/lib/createPageApp'
import BioPage from './BioPage.vue'

createPageApp(BioPage).mount()
